module.exports = __webpack_public_path__ + "img/img9.9195b570.png";